import { ProfileForm } from './types'
import { REGEX_EMAIL } from '../../config'

export const getEmailValid = (email: string) => REGEX_EMAIL.test(email)
export const getPhoneValid = (phoneNumber: string) =>
  phoneNumber.replace(/\D/gi, '').length === 10
export const getZipValid = (zip: string) => zip.length === 5
export const getCCValid = (isAmex: boolean, cardNumber: string) =>
  (isAmex && cardNumber.replace(/\D/gi, '').length === 15) ||
  (!isAmex && cardNumber.replace(/\D/gi, '').length === 16)
export const getCCVValid = (isAmex: boolean, cardCode: string) =>
  (isAmex && cardCode.replace(/\D/gi, '').length === 4) ||
  (!isAmex && cardCode.replace(/\D/gi, '').length === 3)
export const getCCExpDateValid = (expirationDate: string) =>
  expirationDate.replace(/\D/gi, '').length === 4

export const getIsInputValid = ({
  isEmail,
  isPhoneNumber,
  isZip,
  isCCV,
  isCardNumber,
  isExpirationDate,
  isAmex,
  isState,
  isAccountNumberConfirm,
  accountNumber,
  value,
}: {
  isEmail: boolean
  isPhoneNumber: boolean
  isZip: boolean
  isCCV: boolean
  isCardNumber: boolean
  isExpirationDate: boolean
  isAmex: boolean
  isState: boolean
  isAccountNumberConfirm: boolean
  accountNumber: string
  value: string
}) => {
  if (isEmail) return getEmailValid(value)
  if (isPhoneNumber) return getPhoneValid(value)
  if (isZip) return getZipValid(value)
  if (isCCV) return getCCVValid(isAmex, value)
  if (isCardNumber) return getCCValid(isAmex, value)
  if (isExpirationDate) return getCCExpDateValid(value)
  if (isState) return value !== 'undefined'
  if (isAccountNumberConfirm) return value === accountNumber
  return value.length > 3
}

export const getIsFormValid = (profileForm: ProfileForm) => {
  const {
    address,
    city,
    firstName,
    lastName,
    state,
    email,
    phoneNumber,
    zip,
    cardNumber,
    cardCode,
    expirationDate,
  } = profileForm

  const isAmex = /^3[47]/.test(cardNumber)
  if (!address || !city || !firstName || !lastName || !state) return false
  if (!getEmailValid(email)) return false
  if (!getPhoneValid(phoneNumber)) return false
  if (!getZipValid(zip)) return false
  if (!getCCValid(isAmex, cardNumber)) return false
  if (!getCCVValid(isAmex, cardCode)) return false
  return getCCExpDateValid(expirationDate)
}

export const getIsFormValidAchDebit = (profileForm: ProfileForm) => {
  const {
    address,
    city,
    firstName,
    lastName,
    state,
    email,
    phoneNumber,
    zip,
    accountNumber,
    routingNumber,
    nameOnAccount,
    accountNumberConfirm,
  } = profileForm

  if (
    !address ||
    !city ||
    !firstName ||
    !lastName ||
    !state ||
    !accountNumber ||
    !routingNumber ||
    !nameOnAccount
  )
    return false

  if (accountNumber && accountNumber !== accountNumberConfirm) return false

  if (!getEmailValid(email)) return false
  if (!getPhoneValid(phoneNumber)) return false
  return getZipValid(zip)
}
